import { render } from "./UserPasswordChangeForm.vue?vue&type=template&id=2bebfb88"
import script from "./UserPasswordChangeForm.vue?vue&type=script&lang=js"
export * from "./UserPasswordChangeForm.vue?vue&type=script&lang=js"
script.render = render

export default script